import { Component, Input, OnInit } from '@angular/core';
import { SIMULATION_STATUS } from '../../simulation/types';

@Component({
    selector: 'app-expansion-item',
    templateUrl: './expansion-item.component.html',
    styleUrls: ['./expansion-item.component.scss'],
})
export class ExpansionItemComponent implements OnInit {
    @Input() noStatus?: boolean;
    @Input() noButton?: boolean;
    @Input() mode?: string;
    @Input() data?: any;
    @Input() openParticipantForm?: (data: any) => void;
    @Input() formatCellParticipant?: (data: any) => void;
    @Input() formatCell?: (data: any) => void;
    @Input() formMatCellMin?: (data: any) => void;
    @Input() getTemplateDateTime?: (data: any) => void;
    @Input() btnClickAction?: (type: any, dataRow: any) => void;
    @Input() updateUser?: (type: any, dataRow: any) => void;
    @Input() deleteUser?: (type: any, dataRow: any) => void;
    @Input() resetPassword?: (type: any, dataRow: any) => void;
    ENUM_STATUS: any;
    createdBy: any;
    panelOpenState = false;
    constructor() {
        this.ENUM_STATUS = SIMULATION_STATUS;
        // this.createdBy = this.authAppService.getUser()?.sub ?? '';
    }

    ngOnInit() {
        // console.log(this.data);
    }
}
